import React, { useState, useEffect } from 'react';
import Wrapper from './wrapper';

const DIALOG_SELECTOR = '#advisor-booking';
const DIALOG_ATTRIBUTE = 'aria-hidden';

const Profile: React.FunctionComponent = () => {
  const [isDialogClosed, setIsDialogClosed] = useState(
    document.querySelector(DIALOG_SELECTOR)?.getAttribute(DIALOG_ATTRIBUTE) === 'true'
  );

  useEffect(() => {
    const elem = document.querySelector(DIALOG_SELECTOR);
    const overlay = elem?.querySelector('.kt-modal-overlay');

    if (!elem) {
      return;
    }

    // Prevent MicroModal - Kadence Modal to close when clicking outside of the dialog
    overlay?.removeAttribute('data-modal-close');

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === DIALOG_ATTRIBUTE) {
          const target = mutation.target as HTMLDivElement;
          const isClosed = target.getAttribute(DIALOG_ATTRIBUTE) === 'true';
          setIsDialogClosed(isClosed);
        }
      });
    });

    observer.observe(elem, {
      attributes: true, //configure it to listen to attribute changes
    });
  }, []);

  if (isDialogClosed) {
    return <></>;
  }

  return <Wrapper />;
};

export default Profile;
